import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActiveFacetsComponent, FacetService, ProductListComponentService } from "@spartacus/storefront";
import { Observable } from "rxjs";
import { ProductSearchPage } from "@spartacus/core";

/**
 * Active facets render the applied facet values as a list of focusable buttons
 * which can be used to remove the applied facet value.
 */
@Component({
  selector: 'cx-active-facets',
  templateUrl: './custom-active-facets.component.html',
  changeDetection: ChangeDetectionStrategy.Default,
  standalone: false
})
export class CustomActiveFacetsComponent extends ActiveFacetsComponent {
  model$: Observable<ProductSearchPage> = this.productListComponentService
    .model$;

  constructor(
    protected facetService: FacetService,
    private productListComponentService: ProductListComponentService,
  ) {
    super(facetService);
  }
}
